import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSVG = styled.svg.withConfig({
  displayName: "ClearSearchIcon__StyledSVG",
  componentId: "sc-1q82q2a-0"
})(["fill:var(--search-icon-fill);"]);
export const ClearSearchIcon = () => {
  return /*#__PURE__*/_jsxs(StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    children: [/*#__PURE__*/_jsx("g", {
      clipPath: "url(#a)",
      opacity: ".6",
      children: /*#__PURE__*/_jsx("path", {
        d: "M.284 13.743a.867.867 0 0 0 1.235 0L7.012 8.25l5.497 5.494a.873.873 0 1 0 1.235-1.236L8.247 7.014l5.492-5.5a.87.87 0 0 0-1.231-1.23L7.012 5.779 1.514.284a.87.87 0 1 0-1.232 1.23h.001l5.492 5.5-5.492 5.499a.868.868 0 0 0 0 1.23h.001Z"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h14v14H0z"
        })
      })
    })]
  });
};